import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'filterByOffice'
})

export class FilterByOffice implements PipeTransform {
    transform(items: any[], office_id: string): any {
        if(!items || office_id == "all"){
            return items;
        }
        return items.filter(item => item.id_user_office == office_id)
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/filter-byOffice.pipe.ts